import {
  AccessPermissions,
  ApiAuthResponse,
  ApiAuthResponseNormalizedPermissions,
  FilterPermissions,
  LoginPayload,
  LoginPayloadWithCredentials,
  LoginRequestAction,
  LoginSuccessAction,
  LogoutActionRequest,
  LogoutSuccessAction,
  MakeCsrfCallAction,
  MfaLoginAction,
  MfaPayload,
  PermissionsDict,
  SessionExpiredAction,
  SetCurrentUserAction,
  SetLoginErrorCodeAction,
  UpdatePermissions,
  UpdateUserNameAction
} from './auth.types';

export const login = (data: LoginPayload): LoginRequestAction => ({
  type: 'LOGIN_REQUEST',
  payload: data
});

export const loginSuccess = (data: ApiAuthResponseNormalizedPermissions): LoginSuccessAction => ({
  type: 'LOGIN_SUCCESS',
  payload: data
});

export const setCurrentUser = (data: ApiAuthResponse): SetCurrentUserAction => ({
  type: 'SET_CURRENT_USER',
  payload: data
});

export const setLoginErrorCode = (errorCode: number): SetLoginErrorCodeAction => ({
  type: 'SET_LOGIN_ERROR_CODE',
  payload: errorCode
});

export const makeCsrfCall = (data: ApiAuthResponseNormalizedPermissions): MakeCsrfCallAction => ({
  type: 'MAKE_CSRF_CALL',
  payload: data
});

export const logout = (data): LogoutActionRequest => ({
  type: 'LOGOUT_REQUEST',
  payload: data
});

export const logoutSuccess = (): LogoutSuccessAction => ({
  type: 'LOGOUT_SUCCESS'
});

export const sessionExpired = (): SessionExpiredAction => ({
  type: 'SESSION_EXPIRED'
});

export const updateUserName = (name: string): UpdateUserNameAction => ({
  type: 'UPDATE_USER_NAME',
  payload: name
});

export const filterPermissions = (
  filter: (permissions: PermissionsDict) => PermissionsDict
): FilterPermissions => ({
  type: 'FILTER_PERMISSIONS',
  payload: filter
});

export const updatePermissions = (permissions: AccessPermissions[]): UpdatePermissions => ({
  type: 'UPDATE_PERMISSIONS',
  payload: permissions
});

export const mfaLogin = (payload: MfaPayload & LoginPayloadWithCredentials): MfaLoginAction => ({
  type: 'MFA_LOGIN',
  payload
});
